import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { config } from './config';

// Validate credentials before creating client
if (!config.supabase.url || !config.supabase.anonKey) {
  throw new Error('Supabase credentials are missing. The config module should have caught this.');
}

export const supabase = createClient<Database>(
  config.supabase.url,
  config.supabase.anonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  }
);

// Helper to get current user
export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  return user;
};

// Helper to get current user's profile
export const getCurrentProfile = async () => {
  const user = await getCurrentUser();
  if (!user) return null;
  
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', user.id)
    .single();
    
  if (error) throw error;
  return data;
};

// Helper to check if user is admin
export const isAdmin = async () => {
  try {
    const profile = await getCurrentProfile();
    return profile?.role === 'admin';
  } catch {
    return false;
  }
};

// Helper to get user role from JWT
export const getUserRole = async (): Promise<string> => {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.user?.app_metadata?.role || 'patient';
};